import SXRemoteSource from "./SXRemoteSource.js";

export default function SXVideoDelegate(sequences, options){
    this.sequencesMap = {};
    this.sequencesList = [];
    this.sourcesMap = {};
    this.nativeDelegate = null;
    this.listenerId = null;
    this.refCount = 0;

    this.options = {
        onFileLoaded : null,
        onFileUsed : null,
        onFileUnused: null,
        onFileUnusedAll: null
    }

    this.sequenceString = JSON.stringify(sequences);

    this.options = Object.assign({}, this.options, options);

    // 增加引用
    this.used = function() {
        this.refCount++;
    }

    // 减少引用
    this.unused = function() {
        this.refCount--;
    }

    this.canRelease = function(){
        return this.refCount <= 0;
    }

    // 遍历 sequence 创建 SXRemoteSource
    for(var i = 0; i < sequences.list.length; i++) {
        var item = sequences.list[i];
        this.sequencesMap[item.path] = item;
        this.sourcesMap[item.path] = new SXRemoteSource(item.url, item.path);
        this.sequencesList.push(item);
    }

    console.log(this.sequencesList);

    this.release = function() {
        if (!this.canRelease()) {
            return false;
        }

        console.log("release video delegate")
        if (window["FS"]) {
            for(let key in this.sequencesMap) {
                let file = this.sequencesMap[key];
                let source = this.sourcesMap[key];
                try {
                    if (source.isLoaded) {
                        source.unload();
                    }
                } catch (e) {

                } 
            }
        }

        // @TODO release native delegate
        // this.nativeDelegate.delete();
    }

    this.getSource = function(filePath) {
        return this.sequencesMap[filePath];
    }

    // 如果时间时间点超过了最后一个片段，说明要使用最后一个片段
    this.getRemoteSourceAt = function(time) {
        let list = [];

        for(let i = 0; i < this.sequencesList.length; i++) {
            let file = this.sequencesList[i];
            let source = this.sourcesMap[file.path];
            if (source.isLoaded || source.isLoading ) {
                continue;
            }

            if (file.localStart <= time && file.localEnd >= time) {
                list.push(source);
            }

            // 最后一个素材
            if (i == (this.sequencesList.length - 1) && file.localEnd < time) {
                list.push(source);
            }
        }

        return list;
    }

    this.getRemoteSourceBetween = function(start, end) {
        let list = [];


        for(let i = 0; i < this.sequencesList.length; i++) {
            let file = this.sequencesList[i];
            let source = this.sourcesMap[file.path];
            if (source.isLoaded || source.isLoading ) {
                continue;
            }

            if ((file.localStart >= start && file.localStart <= end)
            || (file.localEnd >= start && file.localEnd <= end)
            ) {
                list.push(source);
            }

            // 最后一个素材
            if (i == this.sequencesList.length - 1 && file.localEnd < start) {
                list.push(source);
            }
        }
        
        return list;
    }

    // 使用 file 时回调
    // @param filePath, 文件路径
    // @param time, 使用的时间
    this.onFileUsed  = function(filePath, useTime) {

        // 从列表中找到要加载的 source
        var source =  this.sequencesMap[filePath];
        var remoteSource =this.sourcesMap[filePath];

        // 加载素材
        if (!remoteSource.isLoading || !remoteSource.isLoaded ) {
            remoteSource.load().then(ret => {
                if (this.options.onFileLoaded) { 
                    this.options.onFileLoaded({filePath: filePath, useTime : useTime, source : source, delegate: this});
                }
            })
        }

        if (remoteSource.isLoaded) {
            return true;
        }

        if (this.options.onFileUsed) { 
            this.options.onFileUsed({filePath: filePath, useTime : useTime, source : source, delegate : this});
        }


        return false;
    };

    // 不使用 file 时回调
    // @param filePath, 文件路径
    this.onFileUnused = function(filePath) {
        if (this.options.onFileUnused){ 
            var source =  this.sequencesMap[filePath];
            this.options.onFileUnused({filePath : filePath, source : source,  delegate : this});
        }
    };

    // 不使用所有 file 时回调
    this.onUnusedAll = function() {
        if (this.options.onFileUnusedAll){ 
            this.options.onFileUnusedAll({delegate : this});
        }
    }

    this.setNativeDelegate  = function(delegate) {
        this.nativeDelegate = delegate;
    }

    this.getNativeDelegate = function() {
        return this.nativeDelegate;
    }

    this.setListenerId = function(id) {
        this.listenerId = id;
    }

    this.getListenerId = function() {
        return this.listenerId;
    }
}
